import { render, staticRenderFns } from "./addPerson.vue?vue&type=template&id=6c057590&scoped=true&"
import script from "./addPerson.vue?vue&type=script&lang=js&"
export * from "./addPerson.vue?vue&type=script&lang=js&"
import style0 from "./addPerson.vue?vue&type=style&index=0&id=6c057590&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c057590",
  null
  
)

component.options.__file = "addPerson.vue"
export default component.exports